import { render, staticRenderFns } from "./CommandAssistant2.vue?vue&type=template&id=1f78a516&scoped=true&"
import script from "./CommandAssistant2.vue?vue&type=script&lang=js&"
export * from "./CommandAssistant2.vue?vue&type=script&lang=js&"
import style0 from "./CommandAssistant2.vue?vue&type=style&index=0&id=1f78a516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f78a516",
  null
  
)

export default component.exports